// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalBiAddress } from './medicalBiAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiPrescriberResult {
    'inNetwork'?: string;
    'networkStatus'?: string;
    'address'?: MedicalBiAddress | null;
    'fax'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'npi'?: string;
    'taxId'?: string;
    'ptan'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiPrescriberResult>> = [
        {
            "name":     "inNetwork",
            "baseName": "inNetwork",
            "type":     "string"
        },
        {
            "name":     "networkStatus",
            "baseName": "networkStatus",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalBiAddress"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "ptan",
            "baseName": "ptan",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiPrescriberResult.attributeTypeMap;
    }
}
